/*=========================================================================================
  File Name: modulePurchaseState.js
  Description: Purchase Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  purchases: [], //Total Purchases List
};
